import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import planApiClient, { CreatePlanDto, PlanStatus } from "api/plan";

export const usePlansQuery = () =>
  useQuery({
    queryKey: ["admin-plans"],
    queryFn: () => planApiClient.getAvailablePlans(),
  });

export const useCreatePlanMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreatePlanDto) => planApiClient.createPlan(dto),
    onSettled: () => queryClient.refetchQueries({ queryKey: ["admin-plans"] }),
  });
};

export const useUpdatePlanStatusMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ planId, status }: { planId: string; status: PlanStatus }) =>
      planApiClient.updateStatus(planId, status),
    onSettled: () => queryClient.refetchQueries({ queryKey: ["admin-plans"] }),
  });
};

export const useUpdatePlanContentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      planId,
      data,
    }: {
      planId: string;
      data: { title?: string; explanation?: string };
    }) => planApiClient.updateContent(planId, data),
    onSettled: () => queryClient.refetchQueries({ queryKey: ["admin-plans"] }),
  });
};
